import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getDacastVideoId } from '../../../../app/functions';
import { updateVideoArticlesViewCount } from '../../../../redux/actions';
import * as routes from '../../../../constants/routes';
import closeIcon from '../../../../assets/magazine/icons/icons-close.svg';
import './index.scss';
import { useMarkArticleViewMutation } from '../../../../redux/api/content.api';
const VideoArticle = ({
    article,
    handleClose,
    shouldRedirect = false,
    buttonText = undefined,
    buttonLink = undefined,
}) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const translations = useSelector((store) => store.config.Translations);

    const videoId = getDacastVideoId(article['video_link']);

    const containerRef = useRef(null);

    const [markArticleView] = useMarkArticleViewMutation();

    const seeMoreHandler = () => {
        history.push(buttonLink || `${routes.magazine}/${translations['magazine_video_category']}`);
        handleClose();
    };


    const buildQuery = (id)=> {
        const search =  history.location.search || '';


        return search.replace(/videoId=(\d+)&?/, '')
    }
    useEffect(() => {

        let player;
        if (videoId) {
            player = document.createElement('script');
            player.src = '//player.dacast.com/js/player.js';
            player.defer = 'defer';
            player.onload = () => {
                const Player = window.dacast(videoId, 'dacastVideoPlayer');

                // Make the video autoplay when ready
                Player.onReady(() => {
                    if (containerRef.current) {
                        Player.play();
                    }
                });

                // Update the views counter
                markArticleView(article.id);
            };
            document.head.appendChild(player);
        }

        // Update the URL when the popup opens/closes
        if (shouldRedirect) {

             const query = buildQuery()
            let search  = `videoId=${article['id']}`
            if(query?.startsWith('?')){
                search  = query.substring(1)+`&${search}`
            }

            history.push({
                search: `?${search}`,
            });
            return () => {
                if(player) {
                    document.head.removeChild(player);
                }
                history.push({
                    search: query,
                });
            }
        }
        return () => {
            if(player) {
                document.head.removeChild(player);
            }
        }
    }, []);


    return (
        <div className='video-article-popup-wrapper' ref={containerRef}>
            <div className="backdrop" onClick={handleClose} />

            <div className="overlay">
                <div className="close" onClick={handleClose}>
                    <img src={closeIcon} alt="כפתור סגירה" className='close-img' />
                </div>

                <div className="video-wrapper">
                    <div id={'dacastVideoPlayer'} className="video-element" />

                    {!videoId && (
                        <div className="error-wrapper">
                            {translations['magazine_video_popup_error']}
                        </div>
                    )}
                </div>

                <div className="footer">
                    <div className="details">
                        <div className="headline">
                            {article['title']}
                        </div>

                        <div className="subline">
                            {article['sub_title']}
                        </div>
                    </div>

                    <div className="see-more">
                        <div className="see-more-btn" onClick={seeMoreHandler}>
                            {buttonText || translations['magazine_video_popup_see_more']}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VideoArticle;
